//Layout

import "./footer.scss";
import "./navbar.scss";
import "./featured.scss";
import "./list.scss";
import "./index.css";
import "./watch.scss";
import "./section1.scss";
import "./frequent.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function CssImports() {
  return null;
}
